module.exports = __webpack_public_path__ + "img/product-packages.f0f37640.jpg";